import { FC } from 'react';
import { useIntl } from 'react-intl';
import { CalculatorHeading } from '../CalculatorHeading';
import { CalculatorText } from '../CalculatorText';
import { FormSelect } from '../FormSelect';
import { ISelectOption } from '../Select/types';
import { CalculatorSelectProps } from './types';

export const CalculatorSelect: FC<CalculatorSelectProps> = ({
  name,
  textKey,
  titleKey,
  rules,
  className,
  options,
  selectProps,
  placeholderKey,
  shouldShowAdornment = false,
  onChangeEffect,
}) => {
  const intl = useIntl();

  return (
    <div className={className}>
      <CalculatorHeading labelKey={titleKey} />
      {textKey && <CalculatorText labelKey={textKey} />}
      <FormSelect
        name={name}
        rules={rules}
        className={'mt-2'}
        options={options}
        shouldShowAdornment={shouldShowAdornment}
        selectProps={{
          isOptionEqualToValue: (option: ISelectOption, selectedOption: ISelectOption) =>
            option.value === selectedOption.value,
          ...selectProps,
        }}
        selectInputProps={{
          placeholder: intl.formatMessage({ id: placeholderKey }),
        }}
        onChangeEffect={onChangeEffect}
      />
    </div>
  );
};
